// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //Heroku
  //Localurl: "https://api-sunumarket.herokuapp.com/",

  //Pack Simple
  //Localurl: "http://174.138.46.191:8080/",

  //Pack Basic
  //Localurl: "http://157.230.215.133:8080/",

  //Pack Pro
  Localurl: "http://157.230.219.129:8080/",

  //LocalHost
  //Localurl: "http://localhost:8080/",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
